import { useEffect, useState } from "react";
import { DownloadSimple, ShareNetwork, X } from "@phosphor-icons/react";

export default function PwaInstallPrompt() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [visible, setVisible] = useState(false);
    const [isIos] = useState(() => /iphone|ipad|ipod/i.test(window.navigator.userAgent));
    const [dismissed, setDismissed] = useState(() => localStorage.getItem("pwa_prompt_dismissed") === "1");

    useEffect(() => {
        if (dismissed) return undefined;
        const alreadyInstalled = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
        if (alreadyInstalled) return undefined;
        const handler = (event) => {
            event.preventDefault();
            setDeferredPrompt(event);
            setVisible(true);
        };
        window.addEventListener("beforeinstallprompt", handler);
        // Bila browser tidak mengirim beforeinstallprompt (mis. belum cukup interaksi),
        // tetap tampilkan panduan pemasangan manual setelah beberapa detik
        const timer = setTimeout(() => setVisible(true), isIos ? 4000 : 8000);
        return () => {
            window.removeEventListener("beforeinstallprompt", handler);
            if (timer) clearTimeout(timer);
        };
    }, [dismissed, isIos]);

    if (!visible || dismissed) return null;

    const install = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        await deferredPrompt.userChoice;
        setVisible(false);
        setDeferredPrompt(null);
    };

    const close = () => {
        setVisible(false);
        setDismissed(true);
        localStorage.setItem("pwa_prompt_dismissed", "1");
    };

    return (
        <div data-testid="pwa-install-banner" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-50 border border-racing-line bg-white shadow-2xl">
            <div className="flex items-start gap-3 p-4">
                <img src="/icons/pwa-192.png" alt="" className="w-11 h-11 border border-racing-line shrink-0" />
                <div className="flex-1 min-w-0">
                    <p className="font-display uppercase text-lg text-neutral-900 leading-tight">Pasang Aplikasi Mandalis</p>
                    {isIos ? (
                        <p className="text-xs text-racing-muted mt-1">
                            Di Safari: ketuk tombol <ShareNetwork size={13} className="inline -mt-0.5" /> Bagi, lalu pilih <strong>Tambah ke Layar Utama</strong>.
                        </p>
                    ) : deferredPrompt ? (
                        <p className="text-xs text-racing-muted mt-1">Akses portal orang tua & info klub lebih cepat dari layar utama HP Anda.</p>
                    ) : (
                        <p className="text-xs text-racing-muted mt-1">Di Chrome Android: ketuk menu <strong>⋮</strong> lalu pilih <strong>Instal aplikasi</strong> / <strong>Tambahkan ke layar utama</strong>.</p>
                    )}
                </div>
                <button type="button" onClick={close} data-testid="pwa-install-dismiss" className="text-racing-muted hover:text-racing-red transition-colors shrink-0" aria-label="Tutup">
                    <X size={16} weight="bold" />
                </button>
            </div>
            {!isIos && deferredPrompt && (
                <button
                    type="button"
                    onClick={install}
                    data-testid="pwa-install-button"
                    className="w-full flex items-center justify-center gap-2 bg-racing-red hover:bg-racing-redhover text-white text-xs uppercase tracking-[0.2em] py-3 transition-colors"
                >
                    <DownloadSimple size={15} weight="bold" /> Pasang Sekarang
                </button>
            )}
        </div>
    );
}
